// Copyright (C) Microsoft Corporation. All rights reserved.

import { TabControl } from './TabControl';

// Initialize tab controls on the page
// (assumes script is deferred so DOM is parsed before execution)
document.querySelectorAll('.tabGroup').forEach(e => {
	new TabControl(e);
});
